import React from 'react'

// 
// import React from 'react'

const Header = () => {
  return (
    <div>
    <img className="" src="/src/resources/wp.jpg" alt=""/>

    </div>
  )
}

export default Header
